import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Slider from 'react-slick';

import map from 'lodash/fp/map';

import styled from '@emotion/styled';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import ProductCard from '../ProductCard';

const StyledSlider = styled(Slider)`
  width: 100%;
  .slick-dots {
    bottom: 12px;
    li {
      margin: -4px;
    }
    li button {
      padding: 0;
    }
    li button:before {
      color: ${props => props.theme.palette.common.beige.light};
      opacity: 0.25;
    }
    li.slick-active button:before {
      color: white;
      opacity: 1;
    }
  }
  .slick-track .slick-slide:last-child {
    padding-right: 18px;
  }
`;

const SliderCardsContainer = styled('div')`
  padding: 0 0px 72px 18px;
  ${props => props.theme.breakpoints.up('sm')} {
    padding: 0 0px 72px 18px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    padding: 0 0 72px 0;
  }
`;

const Dot = styled('div')`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${props => props.theme.palette.common.vert.dark};
  opacity: ${props => (props.currentSlide === props.index ? '1' : '0.25')};
`;

const MobileCustomSlider = ({ fetchedProducts }) => {
  const { isMobile } = useResponsiveVariant();
  const [currentSlide, setCurrentSlide] = useState(0);
  const hasNewLabel = productLabel => {
    const isNewArray = ['Cleanser', 'Moisturizer', 'Serum'];
    return isNewArray.includes(productLabel);
  };
  const cards = map(product => {
    return (
      <Fragment key={product.label}>
        <SliderCardsContainer>
          <ProductCard isNew={hasNewLabel(product.label)} product={product} />
        </SliderCardsContainer>
      </Fragment>
    );
  }, fetchedProducts);
  const customPaging = i => <Dot currentSlide={currentSlide} index={i} />;
  const slidesToShowValue = isMobile ? 1.2 : 2.5;

  return (
    <StyledSlider
      // The slide value can be a float because of a weird trick we need to do to display only one percentage of a card in the slider
      afterChange={slide => setCurrentSlide(Math.round(slide))}
      allowAsProps
      arrows={false}
      customPaging={customPaging}
      dots
      focusOnSelect
      infinite={false}
      slidesToShow={slidesToShowValue}
    >
      {cards}
    </StyledSlider>
  );
};

MobileCustomSlider.propTypes = {
  fetchedProducts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      capacity: PropTypes.string,
      priceWithSubscription: PropTypes.number,
      bgLabelledPicture: srcOrNextImageProp,
      productPageUrl: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default MobileCustomSlider;
